var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccreditationAwaiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8157",
    "data-name": "Rectangle 8157",
    width: 28,
    height: 28,
    transform: "translate(-2 -2)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15576",
    "data-name": "Group 15576",
    transform: "translate(1.896 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15575",
    "data-name": "Group 15575",
    transform: "translate(0.104)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5375",
    "data-name": "Path 5375",
    d: "M11.7,0a11.7,11.7,0,1,0,11.7,11.7A11.685,11.685,0,0,0,11.7,0m5.055,14.73a1.152,1.152,0,0,1-1.561.463l-3.817-2.063a2.129,2.129,0,0,1-1.12-1.881V4.762A1.152,1.152,0,0,1,11.4,3.61h.01a1.152,1.152,0,0,1,1.15,1.152V11.15l3.726,2.019a1.152,1.152,0,0,1,.463,1.561",
    transform: "translate(-0.123)",
    fill: "#ff7600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5376",
    "data-name": "Path 5376",
    d: "M48.138,25.78a1.152,1.152,0,0,1-1.561.463L42.76,24.18A2.129,2.129,0,0,1,41.64,22.3V15.812a1.152,1.152,0,0,1,1.15-1.152h.01a1.152,1.152,0,0,1,1.15,1.152V22.2l3.726,2.019a1.152,1.152,0,0,1,.463,1.561",
    transform: "translate(-31.51 -11.05)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccreditationAwaiting);
export default __webpack_public_path__ + "static/media/accreditation-awaiting.2608d05baa7d0478bf928665814df506.svg";
export { ForwardRef as ReactComponent };